import { useState } from "react";
import { ChevronDown } from "lucide-react";
import type { Message } from "../api";

// Ligne « À : … » d'un e-mail, dépliable (comme Gmail) pour révéler les adresses
// complètes To / Cc. Affichée seulement quand le message porte des destinataires.

const nameOf = (a: { email: string; name?: string }) => a.name || a.email;

export function EmailRecipients({
  recipients,
}: {
  recipients: NonNullable<Message["recipients"]>;
}) {
  const [open, setOpen] = useState(false);
  const to = recipients.to ?? [];
  const cc = recipients.cc ?? [];
  if (to.length === 0 && cc.length === 0) return null;
  const summary = [...to, ...cc].map(nameOf).join(", ");
  return (
    <div className={`email-recipients ${open ? "open" : ""}`}>
      <button
        type="button"
        className="email-recipients-summary"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        title={summary}
      >
        <span className="email-recipients-to">À : {summary}</span>
        <ChevronDown size={13} />
      </button>
      {open && (
        <div className="email-recipients-detail">
          {to.length > 0 && (
            <div>
              <span className="email-recipients-label">À</span>{" "}
              {to.map((a) => (a.name ? `${a.name} <${a.email}>` : a.email)).join(", ")}
            </div>
          )}
          {cc.length > 0 && (
            <div>
              <span className="email-recipients-label">Cc</span>{" "}
              {cc.map((a) => (a.name ? `${a.name} <${a.email}>` : a.email)).join(", ")}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
